<template>
  <div>
    <connection-step :model="model" :schema-fetching-allowed="false" />
    <multiple-mapping-step :model="model" />
    <events-step :model="model"></events-step>
  </div>
</template>

<script>
import ConnectionStep from '@/modules/integrations/types/salesforce/ConnectionStep'
import MultipleMappingStep from '@/modules/integrations/types/salesforce/MultipleMappingStep'
import EventsStep from '@/modules/integrations/types/salesforce/EventsStep'

export default {
  name: 'SalesforceSettings',
  components: {
    EventsStep,
    MultipleMappingStep,
    ConnectionStep
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/salesforce/SalesforceSettings.vue